<div class="p-3">
  <div class="modal-header">
    <p class="modal-title">
      <strong>{{
        isEditMode
        ? "Update Immigration Document Visa Mapping"
        : "Create Immigration Document Visa Mapping"
        }}</strong>
    </p>
     <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
  </div>
  <div class="modal-body p-3">
    <form [formGroup]="createForm" class="d-flex flex-column row">
      <div class="row m-0 pt-2">
        <div class="col-4">
          <label>Country</label>
          <ng-select [readonly]="isEditMode || countryId != 0" [items]="countries" [closeOnSelect]="true"
            [multiple]="false" bindLabel="displayText" bindValue="id" formControlName="country"
            (change)="onCountryChange($event)">
          </ng-select>
        </div>
        <div class="col-4">
          <label for="active">Visa type</label>
          <ng-select [items]="visaTypesInfo" [closeOnSelect]="true" [multiple]="false" bindLabel="displayText"
            formControlName="visaType" bindValue="id" [readonly]="isEditMode || visaTypeId != 0" (change)="onVisaTypeChange($event.id)">
          </ng-select>
        </div>
      </div>
      <div class="row m-0 pt-2">
        <div class="col-4">
          <label>Document Type</label>
          <ng-select [items]="documentTypes" [closeOnSelect]="true" [multiple]="false" bindLabel="displayText"
            bindValue="id" formControlName="documentType" (change)="onDocumentTypeChange($event)"
            [readonly]="isEditMode">
          </ng-select>
        </div>
        <div class="col-4">
          <label>Document Name (Value) - CM9</label>
          <ng-select [items]="documentNamesInfo" [closeOnSelect]="true" [multiple]="false" bindLabel="displayText"
            formControlName="documentName" bindValue="id" [readonly]="isEditMode">
          </ng-select>
        </div>
      </div>

      <div class="row g-0">
  <div class="col-auto px-4">
    <label for="isApprover">
      <input id="isApprover" type="checkbox" formControlName="isApprover" (change)="onChkChange($event)" />
      Approver
    </label>
  </div>
  <div class="col-auto px-3">
    <label for="isRequestor">
      <input id="isRequestor" type="checkbox" formControlName="isRequestor" (change)="onChkChange($event)" />
      Requestor
    </label>
  </div>
  <div class="col-auto px-3">
    <label for="inactive">
      <input id="inactive" type="checkbox" formControlName="inactive" (change)="onChkChange($event)" />
      Inactive
    </label>
  </div>
</div>


      <div class="row m-0 py-2">
        <div class="col">
          <label>Document upload instruction</label>
          <textarea class="w-100 form-control form-control-sm" formControlName="instruction"></textarea>
        </div>
      </div>

      <div class="border-top">
        <div class="px-3"><b>Additional information</b></div>
        <div class="row m-0 py-2">
            <div class="col-md-4">
              <label>Office Location</label>
              <ng-select [items]="officeToBeVisited" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="officeToBeVisited" [ngClass]="{'greyed-out': !isFieldEnabled('Office Location')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 3">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 3">
                    <span class="ng-value-label">+{{ items.length - 3 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-4">
              <label>Legal entity</label>
              <ng-select [items]="officeLE" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="officeLE" [ngClass]="{'greyed-out': !isFieldEnabled('Legal Entity')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label" title={{item.displayText}}> {{ (item.displayText &&
                      item.displayText.length>20)? (item.displayText | slice:0:20)+'...':(item.displayText) }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>   
            <div class="col-md-4">
              <label>Rank</label>
              <ng-select [items]="rank" [closeOnSelect]="false" [multiple]="true" bindLabel="rankName"
                bindValue="rankCode" formControlName="ranks" [ngClass]="{'greyed-out': !isFieldEnabled('Rank')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.rankName }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>         
        </div>
        <div class="row m-0">
            <div class="col-md-4">
              <label>Nationality</label>
              <ng-select [items]="nationality" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="nationality" [ngClass]="{'greyed-out': !isFieldEnabled('Nationality')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-4">
              <label>Nationality Type</label>
              <ng-select [items]="nationalityType" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="nationalityType" [ngClass]="{'greyed-out': !isFieldEnabled('Nationality Type')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>   
            <div class="col-md-4">
              <label>Excluded nationality</label>
              <ng-select [items]="nationality" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="excludedNationality" [ngClass]="{'greyed-out': !isFieldEnabled('Excluded Nationality')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>        
        </div>
        <div class="row m-0">  
            <div class="col-md-4">
              <label>Gender</label>
              <ng-select [items]="gender" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="gender" [ngClass]="{'greyed-out': !isFieldEnabled('Gender')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-4">
              <label>Current visa status</label>
              <ng-select [items]="currentVisaStatus" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="currentVisaStatus" [ngClass]="{'greyed-out': !isFieldEnabled('Current Visa Status')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div> 
            <div class="col-md-4">
              <label>Short term visa</label>
              <ng-select [items]="shortTermVisa" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="shortTermVisa" [ngClass]="{'greyed-out': !isFieldEnabled('Short Term Visa')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>     
        </div>
        <div class="row m-0">        
            <div class="col-md-4">
              <label>Type of support</label>
              <ng-select [items]="typeOfSupport" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="typeOfSupport" [ngClass]="{'greyed-out': !isFieldEnabled('Type of Support')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>         
            <div class="col-md-4">
              <label>Employee current location</label>
              <ng-select [items]="employeeCurrentLocation" [closeOnSelect]="false" [multiple]="true"
                bindLabel="displayText" bindValue="id" formControlName="employeeCurrentLocation"  [ngClass]="{'greyed-out': !isFieldEnabled('Employee Current Location')}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label"> {{ item.displayText }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>         
            <div class="col-md-4">
              <label>Immigration case type</label>
              <ng-select [items]="immigrationCaseType" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                bindValue="id" formControlName="immigrationCaseType" [ngClass]="{'greyed-out': !isFieldEnabled('Immigration Case Type') || hideICT == true}">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                    <span class="ng-value-label" title={{item.displayText}}> {{ (item.displayText &&
                      item.displayText.length>20)? (item.displayText | slice:0:20)+'...':(item.displayText) }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">+{{ items.length - 1 }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
        </div>
        <div class="row m-0">
          <div class="col-auto px-3">
            <label for="mandatory">
              <input id="mandatory" type="checkbox" formControlName="mandatory" />
              Mandatory
            </label>
          </div>
          <div class="col-auto px-3">
            <label for="cm9Filing">
              <input id="cm9Filing" type="checkbox" formControlName="cm9Filing" />
              CM9Filing
            </label>
          </div>
        </div>
      </div>
      <div class="row my-3 text-center">
        <div class="p-3 col">
          <button (click)="createActivity()" eosDebounce class="btn btn-secondary mx-2" type="submit">
            {{ !isEditMode ? "Create" : "Update" }}
          </button>
          <button class="btn btn-outline-primary me-2" (click)="onCancel()">
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
